import { PaginationType } from 'common';
import { FileType } from 'state';
import { AppRootStateType } from 'state/reducers';

export const selectFiles = (state: AppRootStateType): FileType[] => state.files.files;

export const selectFilesPagination = (state: AppRootStateType): PaginationType => ({
  page: state.files.page,
  count: state.files.count ?? 0,
});
